'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en_GB = require('../../date-picker/locale/en_GB');

var _en_GB2 = _interopRequireDefault(_en_GB);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _en_GB2['default'];